import { useRef, useState } from 'react';
// material
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, ListItemIcon, ListItemText, IconButton } from '@mui/material';
// components
import MenuPopover from "@/components/menu-popover/MenuPopover";
import React from 'react';
import { useTranslation } from "react-i18next";
import _ from 'lodash';

const LANGUAGES = [
    {
        id: 0,
        value: 'es',
        label: 'Español',
        icon: '/static/icons/ic_flag_es.svg'
    },
    {
        id: 1,
        value: 'en',
        label: 'English',
        icon: '/static/icons/ic_flag_en.svg'
    },
];

const LanguageSelector = (): any => {
    const { i18n } = useTranslation()

    const anchorRef = useRef(null);

    const [open, setOpen] = useState(false);

    const [option, setOption] = useState(i18n.language)

    const handleOpen = () => {
        setOpen(!open);
    };

    const handleClickClose = (value: string) => (event: any) => {
        event.preventDefault();
        setOption(value);
        setOpen(false);

        if (i18n.isInitialized && i18n.language !== value) {
            i18n.changeLanguage(value).finally(() => console.log('lng changed'));
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getSelectedOption = (): any => {
        return _.find(LANGUAGES, { 'value': option });
    }

    const isMultilingual = process.env.MULTILINGUAL === 'true';

    if (!isMultilingual)
        return null;

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleOpen}
                sx={{
                    padding: 0,
                    width: 44,
                    height: 44,
                    ...(open && {
                        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
                    })
                }}
            >
                <img src={getSelectedOption().icon} alt={getSelectedOption().label} />
            </IconButton>

            <MenuPopover
                open={open}
                onClose={handleClose}
                anchorEl={anchorRef.current}
            >
                <Box sx={{ py: 1 }}>
                    {LANGUAGES.map((option) => (
                        <MenuItem
                            key={option.value}
                            selected={option.value === getSelectedOption().value}
                            onClick={handleClickClose(option.value)}
                            sx={{ py: 1, px: 2.5 }}
                        >
                            <ListItemIcon>
                                <Box component="img" alt={option.label} src={option.icon} />
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                                {option.label}
                            </ListItemText>
                        </MenuItem>
                    ))}
                </Box>
            </MenuPopover>
        </>
    );
}

export default LanguageSelector;
